<template>
  <!--
          作者 tanzhihui
          时间：2020-10-12
          描述：插件-一物一码列表
      -->
  <div class="user">
    <!--添加批次-->
    <div class="d-b-c">
      <div class="mb18"><el-button type="primary" size="small" icon="el-icon-plus" @click="changeProduct" v-auth="'/plus/points/product/add'">添加批次选择商品</el-button></div>
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label=""><el-input v-model="searchForm.search" placeholder="请输入批次名称"></el-input></el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
      <div class="mb18"><el-button size="small" icon="el-icon-plus" type="primary" @click="exportCode">导出编码</el-button></div>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="title" label="批次名称" width="200"></el-table-column>
          <el-table-column prop="product_name" label="商品名称" width="360">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic" style="width: 40px; height: 40px;"><img v-img-url="scope.row.product.image[0].file_path" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.product.product_name }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="rule" label="规则" width="100"></el-table-column>
          <el-table-column prop="rule_start" label="规则开始" width="100"></el-table-column>
          <el-table-column prop="rule_end" label="规则结束" width="100"></el-table-column>
          <el-table-column prop="prefix" label="前缀" width="100"></el-table-column>
          <el-table-column prop="is_zeroize" label="是否补零" width="100" :formatter="is_zeroize"></el-table-column>
          <el-table-column prop="zero_number" label="补零数量" width="100"></el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="300"></el-table-column>
          <el-table-column fixed="right" label="操作" width="300">
            <template slot-scope="scope">
              <el-button @click="clickCode(scope.row.code_batch_id)" type="text" size="small">查看编码</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <!--商品选择-->
    <Product :isproduct="isproduct"  :islist="false" @closeDialog="closeProductFunc"></Product>

    <!--导出编码-->
    <Export v-if="is_show_export" :is_show_export="is_show_export" @closeDialog="closeExportFunc"></Export>
  </div>
    
</template>

<script>
  import CodeBatchApi from '@/api/codebatch.js';
  import Product from '@/components/product/Product.vue';
  import Export from './dialog/Export.vue';
  export default {
    components: {
    /*导出编码*/
    Export,
    Product
  },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        searchForm: {},
        /*是否打开选择商品*/
        isproduct: false,
        /*已有的id*/
        exclude_ids: [],
        // 是否显示导出编码
        is_show_export:false
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
  
    methods: {
      /*查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
    is_zeroize(row, column){
      if (row.is_zeroize === 0) {
          return '正常'
        } else  {
          return '补零'
        } 
    },
     /*打开添加*/
    changeProduct(list) {
      this.isproduct = true;
    },

    /*关闭商品选择*/
    closeProductFunc(e) {
      this.isproduct = false;
      if (e.type == 'success') {
        this.addClick(e.params.product_id);
      }
    },

    /*关闭编码导出*/
    closeExportFunc(e) {
      this.is_show_export = false;
      
    },

    /*添加商品*/
    addClick(product_id) {
      this.$router.push('/plus/codebatch/add?product_id=' + product_id);
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        CodeBatchApi.batchlist(Params, true)
          .then(data => {
            self.loading = false;
            self.exclude_ids = data.data.exclude_ids;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },

      // 导出编码
      exportCode(){
        this.is_show_export = true
      },
      /*查看批次编码*/
      clickCode(e) {
        let self = this;
        self.$router.push({
          path: '/plus/codebatch/code/index',
          query: {
            code_batch_id: e
          }
        });
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/codebatch/index.vue